import { render, staticRenderFns } from "./FileInvoiceDollarButton.vue?vue&type=template&id=d117f200"
import script from "./FileInvoiceDollarButton.vue?vue&type=script&lang=ts"
export * from "./FileInvoiceDollarButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports